const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

const ValoresTable = ({ selectedEstandeInfo }) => {

  const config = {
    fontSizeHeader: "11px", // Cabeçalho um pouco menor para caber
    fontSizeBody: "10px",   // Corpo da tabela
    padding: "8px 4px",     // Padding reduzido (4px nas laterais) para ganhar espaço
    
    // Configuração das larguras das colunas (Soma deve dar 100%)
    colWidths: {
      item: "30%",   // Espaço para o Nome
      qtd: "15%",    // Qtd é curto
      valor: "25%",  // Preço unitário
      total: "30%"   // Preço total
    }
  };

  const headerStyle = {
    padding: config.padding,
    textAlign: "right", // Alinhado a direita por padrão financeiro
    fontSize: config.fontSizeHeader,
    whiteSpace: "nowrap" // Tenta não quebrar o cabeçalho
  };

  const cellStyle = {
    padding: config.padding,
    textAlign: "right",
    fontSize: config.fontSizeBody,
    wordBreak: "break-word", // Permite quebrar palavras se não couber
    verticalAlign: "top"     // Alinha ao topo caso o texto quebre linha
  };

  // Prepara dados
  const kvaInfo = selectedEstandeInfo?.kva?.[0];
  const estacInfo = selectedEstandeInfo?.estacionamento?.[0];

  return (
 
      <div style={{
        background: "#f7f7f7",
        borderRadius: "10px",
      }}>
        
        <table style={{ borderRadius: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed", fontSize: "11px" }}>
          
          {/* Definição explícita das larguras das colunas */}
          <colgroup>
            <col style={{ width: config.colWidths.item }} />
            <col style={{ width: config.colWidths.qtd }} />
            <col style={{ width: config.colWidths.valor }} />
            <col style={{ width: config.colWidths.total }} />
          </colgroup>

          <thead style={{borderTopLeftRadius: "10px", borderTopRightRadius: "10px"}}>
            <tr style={{ background: "#464373", color: "white" }}>
              <th style={{ ...headerStyle, textAlign: "left" }}>Item</th>
              <th style={{ ...headerStyle, textAlign: "center" }}>Qtd</th>
              <th style={headerStyle}>Unit.</th>
              <th style={headerStyle}>Total</th>
            </tr>
          </thead>
          
          <tbody>
            {/* LINHA 1: ÁREA */}
            <tr style={{ borderBottom: "1px solid #ddd" }}>
              <td style={{ ...cellStyle, textAlign: "left", fontWeight: 600 }}>Área</td>
              <td style={{ ...cellStyle, textAlign: "center" }}>{selectedEstandeInfo?.area}</td>
              <td style={cellStyle}>{formatCurrency(selectedEstandeInfo?.valor || 0)}</td>
              <td style={{ ...cellStyle, fontWeight: 700 }}>{formatCurrency(selectedEstandeInfo?.valor_total || 0)}</td>
            </tr>

            {/* LINHA 2: KVA */}
            {kvaInfo && (
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ ...cellStyle, textAlign: "left" }}>KVA</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>
                  {kvaInfo.cobra_por_metro ? selectedEstandeInfo?.area : kvaInfo.quantidade}
                </td>
                <td style={cellStyle}>
                  {formatCurrency(kvaInfo.cobra_por_metro ? kvaInfo.valor : (kvaInfo.valor / kvaInfo.quantidade))}
                </td>
                <td style={cellStyle}>
                  {formatCurrency(kvaInfo.cobra_por_metro ? (kvaInfo.valor * selectedEstandeInfo?.area) : kvaInfo.valor)}
                </td>
              </tr>
            )}

            {/* LINHA 3: ESTACIONAMENTO */}
            {estacInfo && (
              <tr style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ ...cellStyle, textAlign: "left" }}>Estac.</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>{estacInfo.quantidade}</td>
                <td style={cellStyle}>{formatCurrency(estacInfo.valor / estacInfo.quantidade)}</td>
                <td style={cellStyle}>{formatCurrency(estacInfo.valor)}</td>
              </tr>
            )}

            {/* LINHA 4: TAGS (LOOP) */}
            {selectedEstandeInfo?.tags?.map((tag, index) => (
              <tr key={index} style={{ borderBottom: "1px solid #ddd" }}>
                <td style={{ ...cellStyle, textAlign: "left" }}>{tag.nome}</td>
                <td style={{ ...cellStyle, textAlign: "center" }}>
                  {tag.manual && tag.quantidade_salva > 0 ? tag.quantidade_salva :  (tag.cobra_por_metro ? selectedEstandeInfo.area : 1)}
                </td>
                <td style={cellStyle}>
                  {tag.manual && tag.valor_salvo > 0 ? tag.valor_salvo : (tag.cobra_por_metro 
                      ? formatCurrency((tag.valor_total_tag / selectedEstandeInfo.area) || 0)
                      : formatCurrency((tag.valor) || 0))
                  }
                </td>
                <td style={cellStyle}>
                  {formatCurrency(tag.valor_total_tag || 0)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

  );
};

export default ValoresTable;